import { IMAGE_RESOLUTIONS } from 'components/HomepageCarousel/Carousel/constants'

import { useStaticData } from '@mc/static-data-react'

import { SpringboardCarouselTile } from './SpringboardCarouselTile'
import { CarouselItem } from '../constants'

const imageWidth = IMAGE_RESOLUTIONS.md.width * 2
const imageHeight = IMAGE_RESOLUTIONS.md.height * 2

const nameplateAnchorStyle = { transform: 'translateY(0%)' } // Ensures the nameplateImage is anchored to its tile

export const SingleColumnSpringboardCarousel = (): JSX.Element[] => {
  const { carouselItems } = useStaticData<{ carouselItems: CarouselItem[] }>()

  return carouselItems.concat(carouselItems).map((item, index) => (
    <div
      className='mc-mb-3'
      key={item.slug + index}
      style={nameplateAnchorStyle}
    >
      <SpringboardCarouselTile
        imageURL={item.carouselImageURL}
        height={imageHeight}
        width={imageWidth}
        link={item.link}
        title={item.title}
        nameplateImage={item.nameplateImage}
      />
    </div>
  ))
}
